export default __webpack_public_path__ + "static/media/gallery_02.40ee8696.jpg";